var map = {
	"./Anyswap.png": "./src/img/Anyswap.png",
	"./Anyswap.svg": "./src/img/Anyswap.svg",
	"./Artwork.svg": "./src/img/Artwork.svg",
	"./Artwork_cad.svg": "./src/img/Artwork_cad.svg",
	"./Banxa.png": "./src/img/Banxa.png",
	"./CAD_logo.svg": "./src/img/CAD_logo.svg",
	"./CLP_logo.svg": "./src/img/CLP_logo.svg",
	"./CadIcon-min.png": "./src/img/CadIcon-min.png",
	"./DROP_DOWN.svg": "./src/img/DROP_DOWN.svg",
	"./Hop.png": "./src/img/Hop.png",
	"./Hop.svg": "./src/img/Hop.svg",
	"./Hop_dark.png": "./src/img/Hop_dark.png",
	"./Hop_dark.svg": "./src/img/Hop_dark.svg",
	"./Synapse.png": "./src/img/Synapse.png",
	"./Synapse.svg": "./src/img/Synapse.svg",
	"./binance.png": "./src/img/binance.png",
	"./bitkeep.svg": "./src/img/bitkeep.svg",
	"./bscscan.png": "./src/img/bscscan.png",
	"./btn_big_arbitrum.png": "./src/img/btn_big_arbitrum.png",
	"./btn_big_avalanche.png": "./src/img/btn_big_avalanche.png",
	"./btn_big_bsc.png": "./src/img/btn_big_bsc.png",
	"./btn_big_purchasecad.png": "./src/img/btn_big_purchasecad.png",
	"./btn_big_purchasecad.svg": "./src/img/btn_big_purchasecad.svg",
	"./buy_cad.svg": "./src/img/buy_cad.svg",
	"./buy_cad_bond.svg": "./src/img/buy_cad_bond.svg",
	"./buy_transfer_eth.svg": "./src/img/buy_transfer_eth.svg",
	"./cad_title_long.png": "./src/img/cad_title_long.png",
	"./cad_title_long_higher.png": "./src/img/cad_title_long_higher.png",
	"./cadence.svg": "./src/img/cadence.svg",
	"./cadence_logo (1).svg": "./src/img/cadence_logo (1).svg",
	"./cadtitle_logo.svg": "./src/img/cadtitle_logo.svg",
	"./clpIcon.png": "./src/img/clpIcon.png",
	"./cnote (2).svg": "./src/img/cnote (2).svg",
	"./coinbaseWallet.png": "./src/img/coinbaseWallet.png",
	"./coingecko.png": "./src/img/coingecko.png",
	"./cross.svg": "./src/img/cross.svg",
	"./downarrow.svg": "./src/img/downarrow.svg",
	"./downarrow1.svg": "./src/img/downarrow1.svg",
	"./downarrow2.svg": "./src/img/downarrow2.svg",
	"./emptyTokenIcon-min.png": "./src/img/emptyTokenIcon-min.png",
	"./esCadIcon-min.png": "./src/img/esCadIcon-min.png",
	"./flag_de.svg": "./src/img/flag_de.svg",
	"./flag_en.svg": "./src/img/flag_en.svg",
	"./flag_es.svg": "./src/img/flag_es.svg",
	"./flag_fr.svg": "./src/img/flag_fr.svg",
	"./flag_ja.svg": "./src/img/flag_ja.svg",
	"./flag_ko.svg": "./src/img/flag_ko.svg",
	"./flag_ru.svg": "./src/img/flag_ru.svg",
	"./flag_zh.svg": "./src/img/flag_zh.svg",
	"./gateio.svg": "./src/img/gateio.svg",
	"./graphite-01.png": "./src/img/graphite-01.png",
	"./ic-communityproject.svg": "./src/img/ic-communityproject.svg",
	"./ic_1inch.svg": "./src/img/ic_1inch.svg",
	"./ic_across.svg": "./src/img/ic_across.svg",
	"./ic_arbitrum_16.svg": "./src/img/ic_arbitrum_16.svg",
	"./ic_arbitrum_24.svg": "./src/img/ic_arbitrum_24.svg",
	"./ic_arbitrum_96.svg": "./src/img/ic_arbitrum_96.svg",
	"./ic_arbitrum_hover_16.svg": "./src/img/ic_arbitrum_hover_16.svg",
	"./ic_arrowleft16.svg": "./src/img/ic_arrowleft16.svg",
	"./ic_arrowright16.svg": "./src/img/ic_arrowright16.svg",
	"./ic_atom_24.svg": "./src/img/ic_atom_24.svg",
	"./ic_atom_40.svg": "./src/img/ic_atom_40.svg",
	"./ic_avalanche_16.svg": "./src/img/ic_avalanche_16.svg",
	"./ic_avalanche_24.svg": "./src/img/ic_avalanche_24.svg",
	"./ic_avalanche_96.svg": "./src/img/ic_avalanche_96.svg",
	"./ic_avalanche_testnet_16.svg": "./src/img/ic_avalanche_testnet_16.svg",
	"./ic_avalanche_testnet_24.svg": "./src/img/ic_avalanche_testnet_24.svg",
	"./ic_avalanche_testnet_96.svg": "./src/img/ic_avalanche_testnet_96.svg",
	"./ic_avax_24.svg": "./src/img/ic_avax_24.svg",
	"./ic_avax_30.svg": "./src/img/ic_avax_30.svg",
	"./ic_avax_40.svg": "./src/img/ic_avax_40.svg",
	"./ic_banxa.svg": "./src/img/ic_banxa.svg",
	"./ic_binance.svg": "./src/img/ic_binance.svg",
	"./ic_binance_logo.svg": "./src/img/ic_binance_logo.svg",
	"./ic_bondprotocol_arbitrum.svg": "./src/img/ic_bondprotocol_arbitrum.svg",
	"./ic_bsc.svg": "./src/img/ic_bsc.svg",
	"./ic_bsc_96.svg": "./src/img/ic_bsc_96.svg",
	"./ic_btc.b_24.svg": "./src/img/ic_btc.b_24.svg",
	"./ic_btc.b_40.svg": "./src/img/ic_btc.b_40.svg",
	"./ic_btc_24.svg": "./src/img/ic_btc_24.svg",
	"./ic_btc_40.svg": "./src/img/ic_btc_40.svg",
	"./ic_bungee.png": "./src/img/ic_bungee.png",
	"./ic_busd_24.svg": "./src/img/ic_busd_24.svg",
	"./ic_buy_clp.svg": "./src/img/ic_buy_clp.svg",
	"./ic_bybit.svg": "./src/img/ic_bybit.svg",
	"./ic_cad.svg": "./src/img/ic_cad.svg",
	"./ic_cad_arbitrum.svg": "./src/img/ic_cad_arbitrum.svg",
	"./ic_cad_avax.svg": "./src/img/ic_cad_avax.svg",
	"./ic_cad_big.svg": "./src/img/ic_cad_big.svg",
	"./ic_canto.svg": "./src/img/ic_canto.svg",
	"./ic_canto_24.svg": "./src/img/ic_canto_24.svg",
	"./ic_canto_24444.svg": "./src/img/ic_canto_24444.svg",
	"./ic_canto_40.svg": "./src/img/ic_canto_40.svg",
	"./ic_canto_4000.svg": "./src/img/ic_canto_4000.svg",
	"./ic_cantoo.svg": "./src/img/ic_cantoo.svg",
	"./ic_cash.png": "./src/img/ic_cash.png",
	"./ic_cash.svg": "./src/img/ic_cash.svg",
	"./ic_checked.svg": "./src/img/ic_checked.svg",
	"./ic_cnote_24.svg": "./src/img/ic_cnote_24.svg",
	"./ic_cnote_244.svg": "./src/img/ic_cnote_244.svg",
	"./ic_cnote_24444.svg": "./src/img/ic_cnote_24444.svg",
	"./ic_cnote_40.svg": "./src/img/ic_cnote_40.svg",
	"./ic_cnote_40000.svg": "./src/img/ic_cnote_40000.svg",
	"./ic_coingecko_16.svg": "./src/img/ic_coingecko_16.svg",
	"./ic_coingecko_hover_16.svg": "./src/img/ic_coingecko_hover_16.svg",
	"./ic_convert_down.svg": "./src/img/ic_convert_down.svg",
	"./ic_copy_16.svg": "./src/img/ic_copy_16.svg",
	"./ic_cost.svg": "./src/img/ic_cost.svg",
	"./ic_dai_24.svg": "./src/img/ic_dai_24.svg",
	"./ic_dai_40.svg": "./src/img/ic_dai_40.svg",
	"./ic_discord.svg": "./src/img/ic_discord.svg",
	"./ic_dodo.svg": "./src/img/ic_dodo.svg",
	"./ic_eth_24.svg": "./src/img/ic_eth_24.svg",
	"./ic_eth_40.svg": "./src/img/ic_eth_40.svg",
	"./ic_firebird.png": "./src/img/ic_firebird.png",
	"./ic_frax_24.svg": "./src/img/ic_frax_24.svg",
	"./ic_frax_40.svg": "./src/img/ic_frax_40.svg",
	"./ic_github.svg": "./src/img/ic_github.svg",
	"./ic_hop.svg": "./src/img/ic_hop.svg",
	"./ic_huobi.svg": "./src/img/ic_huobi.svg",
	"./ic_info.svg": "./src/img/ic_info.svg",
	"./ic_inj_24.svg": "./src/img/ic_inj_24.svg",
	"./ic_inj_40.svg": "./src/img/ic_inj_40.svg",
	"./ic_kucoin.svg": "./src/img/ic_kucoin.svg",
	"./ic_kyberswap.svg": "./src/img/ic_kyberswap.svg",
	"./ic_language24.svg": "./src/img/ic_language24.svg",
	"./ic_link_24.svg": "./src/img/ic_link_24.svg",
	"./ic_link_40.svg": "./src/img/ic_link_40.svg",
	"./ic_liquidity.svg": "./src/img/ic_liquidity.svg",
	"./ic_matcha.png": "./src/img/ic_matcha.png",
	"./ic_medium.svg": "./src/img/ic_medium.svg",
	"./ic_menu_dots.svg": "./src/img/ic_menu_dots.svg",
	"./ic_metamask_16.svg": "./src/img/ic_metamask_16.svg",
	"./ic_metamask_hover_16.svg": "./src/img/ic_metamask_hover_16.svg",
	"./ic_mim_24.svg": "./src/img/ic_mim_24.svg",
	"./ic_mim_40.svg": "./src/img/ic_mim_40.svg",
	"./ic_multichain.svg": "./src/img/ic_multichain.svg",
	"./ic_new_link_16.svg": "./src/img/ic_new_link_16.svg",
	"./ic_o3.png": "./src/img/ic_o3.png",
	"./ic_odos.png": "./src/img/ic_odos.png",
	"./ic_olympus.svg": "./src/img/ic_olympus.svg",
	"./ic_olympus_arbitrum.svg": "./src/img/ic_olympus_arbitrum.svg",
	"./ic_openocean.svg": "./src/img/ic_openocean.svg",
	"./ic_paraswap.svg": "./src/img/ic_paraswap.svg",
	"./ic_selector_dropdowns.svg": "./src/img/ic_selector_dropdowns.svg",
	"./ic_settings_16.svg": "./src/img/ic_settings_16.svg",
	"./ic_settings_24.svg": "./src/img/ic_settings_24.svg",
	"./ic_sign in_16.svg": "./src/img/ic_sign in_16.svg",
	"./ic_sign_out_16.svg": "./src/img/ic_sign_out_16.svg",
	"./ic_simpleswaps.svg": "./src/img/ic_simpleswaps.svg",
	"./ic_slingshot.svg": "./src/img/ic_slingshot.svg",
	"./ic_stats.svg": "./src/img/ic_stats.svg",
	"./ic_stats_big.svg": "./src/img/ic_stats_big.svg",
	"./ic_synapse.svg": "./src/img/ic_synapse.svg",
	"./ic_tansak.svg": "./src/img/ic_tansak.svg",
	"./ic_telegram.svg": "./src/img/ic_telegram.svg",
	"./ic_tether_24.svg": "./src/img/ic_tether_24.svg",
	"./ic_tokens.svg": "./src/img/ic_tokens.svg",
	"./ic_totaluser.svg": "./src/img/ic_totaluser.svg",
	"./ic_traderjoe_avax.png": "./src/img/ic_traderjoe_avax.png",
	"./ic_trading.svg": "./src/img/ic_trading.svg",
	"./ic_transfer_avax.svg": "./src/img/ic_transfer_avax.svg",
	"./ic_twitter.svg": "./src/img/ic_twitter.svg",
	"./ic_uni_24.svg": "./src/img/ic_uni_24.svg",
	"./ic_uni_40.svg": "./src/img/ic_uni_40.svg",
	"./ic_uni_arbitrum.svg": "./src/img/ic_uni_arbitrum.svg",
	"./ic_unidex.png": "./src/img/ic_unidex.png",
	"./ic_usdc.e_24.svg": "./src/img/ic_usdc.e_24.svg",
	"./ic_usdc.e_40.svg": "./src/img/ic_usdc.e_40.svg",
	"./ic_usdc_24.svg": "./src/img/ic_usdc_24.svg",
	"./ic_usdc_40.svg": "./src/img/ic_usdc_40.svg",
	"./ic_usdt_24.svg": "./src/img/ic_usdt_24.svg",
	"./ic_usdt_40.svg": "./src/img/ic_usdt_40.svg",
	"./ic_wallet_24.svg": "./src/img/ic_wallet_24.svg",
	"./ic_wavax_24.svg": "./src/img/ic_wavax_24.svg",
	"./ic_wavax_40.svg": "./src/img/ic_wavax_40.svg",
	"./ic_wbtc_24.svg": "./src/img/ic_wbtc_24.svg",
	"./ic_wbtc_40.svg": "./src/img/ic_wbtc_40.svg",
	"./ic_wcanto_24.svg": "./src/img/ic_wcanto_24.svg",
	"./ic_wcanto_40.svg": "./src/img/ic_wcanto_40.svg",
	"./ic_weth_24.svg": "./src/img/ic_weth_24.svg",
	"./ic_weth_40.svg": "./src/img/ic_weth_40.svg",
	"./ic_yield_yak.png": "./src/img/ic_yield_yak.png",
	"./info.png": "./src/img/info.png",
	"./lg_arbitrum.svg": "./src/img/lg_arbitrum.svg",
	"./logo_Cadence.svg": "./src/img/logo_Cadence.svg",
	"./logo_Cadence_home.svg": "./src/img/logo_Cadence_home.svg",
	"./logo_Cadencee.svg": "./src/img/logo_Cadencee.svg",
	"./long.svg": "./src/img/long.svg",
	"./metamask-text.svg": "./src/img/metamask-text.svg",
	"./metamask.png": "./src/img/metamask.png",
	"./nansen_portfolio.svg": "./src/img/nansen_portfolio.svg",
	"./page-not-found.svg": "./src/img/page-not-found.svg",
	"./position-share-bg.png": "./src/img/position-share-bg.png",
	"./pythIcon.svg": "./src/img/pythIcon.svg",
	"./search.svg": "./src/img/search.svg",
	"./sharecardmusicman.png": "./src/img/sharecardmusicman.png",
	"./short.svg": "./src/img/short.svg",
	"./straddle.svg": "./src/img/straddle.svg",
	"./swap.svg": "./src/img/swap.svg",
	"./test2.png": "./src/img/test2.png",
	"./trading.jpg": "./src/img/trading.jpg",
	"./wallet-connect-text.svg": "./src/img/wallet-connect-text.svg",
	"./walletconnect-circle-blue.svg": "./src/img/walletconnect-circle-blue.svg",
	"./wave-01.png": "./src/img/wave-01.png",
	"./wave-02.png": "./src/img/wave-02.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";